import { Component, OnInit, Input } from "@angular/core";
// import _ from 'lodash';
// import * as moment from 'moment';
// import { SynTaskService } from './syn-task.service';
// import { Router } from '@angular/router';
// import { NzModalRef } from 'ng-zorro-antd/modal';
// import { TranslateService } from '@root/shared/service/translate.service';
// import { WritePermissionGurd } from '@root/util/decorator';

import { NzModalService } from "ng-zorro-antd/modal";
import { HttpClient } from "@angular/common/http";
import { chunk } from "lodash";
import { NzMessageService } from "ng-zorro-antd/message";
import { TranslateService } from "@root/shared/service/translate.service";
enum TaskStatus {
  Success = "success",
  Failed = "failed",
  InProgress = "in_progress",
  PartiallyFailed = "partially_failed",
}

@Component({
  selector: "host-sync-tasks-sub-list",
  templateUrl: "./syn-task-list.component.html",
  styleUrls: ["./syn-task-list.component.scss"],
})
export class SyncTasksSubListComponent implements OnInit {
  private readonly ListApi = "/api/task/batch_detail";
  private readonly RetryApi = "/api/task/retry";

  readonly TaskStatus: typeof TaskStatus = TaskStatus;

  readonly StatusMap: Record<TaskStatus, string> = {
    [TaskStatus.Failed]: "word.task_status.failed",
    [TaskStatus.PartiallyFailed]: "word.task_status.partially_failed",
    [TaskStatus.InProgress]: "word.task_status.in_progress",
    [TaskStatus.Success]: "word.task_status.successful",
  };
  @Input() id;
  @Input() taskType: number = 0;
  // taskList = [];
  // total = 0;
  // page = 1;
  // pageSize = 20;
  // loading = false;

  get isFailed() {
    return this.taskType === 1;
  }

  page = 1;
  pageSize = 20;

  total = 0;
  listOfTask = [];

  initialized = false;

  constructor(
    private modal: NzModalService,
    private http: HttpClient,
    private msg: NzMessageService,
    private t: TranslateService,
  ) {}

  ngOnInit() {
    this.fetchTaskList();
  }

  // onClickTask(task) {
  //   this.displaySubTasksModal(task);
  // }

  onClickRetry(task) {
    if (!task.retried && !task.loading) {
      this.requestRetryTask(task);
    }
  }

  onPageChange() {
    this.fetchTaskList();
  }

  onTabChange() {
    this.page = 1;

    this.fetchTaskList();
  }

  private fetchTaskList() {
    const params = {
      page: this.page,
      page_size: this.pageSize,
      id: this.id,
    };

    if (this.isFailed) {
      Object.assign(params, {
        sync_status: "failed",
      });
    }

    this.http.get(this.ListApi, { params }).subscribe((rst: any) => {
      this.initialized = true;

      this.listOfTask = this.formatTaskField(rst?.data?.list);
      this.total = rst?.data?.total;

      console.log("list of task: ", this.listOfTask);
    });
  }

  private requestRetryTask(task) {
    task.loading = true;
    const params = { id: task.task_id };

    this.http.post(this.RetryApi, params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("word.retried"));
        this.fetchTaskList();
      } else {
        task.loading = false;
      }
    });
  }

  private formatTaskField(list: any[]) {
    return list.map((task) => {
      const titles = task.titles;
      const [first, rest] = chunk(titles);
      const title_str = first?.[0] + (rest?.length ? `, ${rest.length}+` : "");
      task.title_str = title_str;
      return task;
    });
  }

  // private displaySubTasksModal(task) {
  //   this.modal.create({
  //     nzTitle: task.format_str,
  //     nzContent: SyncTasksSubListComponent,
  //     nzWidth: 850,
  //     nzFooter: null,
  //     nzComponentParams: {
  //       id: task.id,
  //     },
  //   });
  // }

  // ngOnInit() {
  //   this.fetchTaskList();
  // }

  // onTabChange() {
  //   this.page = 1;

  //   this.fetchTaskList();
  // }

  // fetchTaskList() {
  //   // this.loading = true;

  //   const params = {
  //     page: this.page,
  //     page_size: this.pageSize,
  //     is_failed: this.isFailed ? 1 : 0,
  //     batch_id: this.id,
  //   };

  //   this.synService.getTaskList(params).subscribe((res) => {
  //     if (res.error_code === 0) {
  //       this.loading = false;
  //       this.taskList = _.get(res, 'data.list');
  //       this.total = _.get(res, 'data.count') || 0;
  //       this.formatTaskList();
  //     }
  //   });
  // }

  // formatTaskList() {
  //   _.forEach(this.taskList, (task) => {
  //     const status = _.get(task, 'sync_status');
  //     let _status;
  //     let _color;
  //     switch (status) {
  //       case 0:
  //         // 等待中
  //         _status = this.translateService.t('syn_task.waiting');
  //         _color = '#F5A623';
  //         break;
  //       case 1:
  //         // 执行中
  //         _status = this.translateService.t('syn_task.in_progress');
  //         _color = '#2C80F0';
  //         break;
  //       case 2:
  //         // 成功
  //         _status = this.translateService.t('word.success');
  //         _color = '#6BB935';
  //         break;
  //       case 3:
  //         // 失败
  //         _status = this.translateService.t('word.fail');
  //         _color = '#F45A5A';
  //         break;
  //       case 4:
  //         _status = this.translateService.t('word.success');
  //         _color = '#6BB935';
  //         break;
  //     }
  //     _.forEach(task.change, (change) => {
  //       _.assign(change, {
  //         from:
  //           change.from === true
  //             ? // 打开
  //               this.translateService.t('component.month_calendar_v2.open')
  //             : change.from === false
  //             ? // 关闭
  //               this.translateService.t('word.close')
  //             : change.from,
  //         to:
  //           change.to === true
  //             ? this.translateService.t('component.month_calendar_v2.open')
  //             : change.to === false
  //             ? this.translateService.t('word.close')
  //             : change.to,
  //       });
  //     });
  //     _.assign(task, {
  //       status: _status,
  //       color: _color,
  //     });
  //   });
  // }

  // onPageChange() {
  //   this.fetchTaskList();
  // }

  // // @WritePermissionGurd("calendar")
  // retry(task) {
  //   this.synService
  //     .retryTask({
  //       id: task.id,
  //     })
  //     .subscribe((res) => {
  //       if (res.error_code === 0) {
  //         this.fetchTaskList();
  //       }
  //     });
  // }

  // toHouseStatusDetail(task) {
  //   console.log(task);
  //   if (task.house_type_id) {
  //     const id = task.house_type_id;
  //     this.router.navigate(['/app/room_types/detail'], {
  //       queryParams: {
  //         id: id,
  //         type: 'type',
  //         activeIndex: 2,
  //         unique_key: task.thirdparty_house_id,
  //       },
  //     });
  //   } else {
  //     const id = task.house_id;
  //     this.router.navigate(['/app/properties/detail'], {
  //       queryParams: {
  //         id: id,
  //         type: 'house',
  //         activeIndex: 2,
  //         unique_key: task.thirdparty_house_id,
  //       },
  //     });
  //   }
  //   this.subject.destroy();
  // }

  // toHousePriceDetail(task) {
  //   if (task.house_type_id) {
  //     const id = task.house_type_id;
  //     this.router.navigate(['/app/room_types/detail'], {
  //       queryParams: {
  //         id: id,
  //         activeIndex: 2,
  //       },
  //     });
  //   } else {
  //     const id = task.house_id;
  //     this.router.navigate(['/app/properties/detail'], {
  //       queryParams: {
  //         id: id,
  //         activeIndex: 2,
  //       },
  //     });
  //   }
  //   this.subject.destroy();
  // }

  // formatDate(date) {
  //   return moment(date).format('MM.DD');
  // }
}
